<div class="shop-info">
  @if (isDropdownOpen){
    <form nz-form [formGroup]="this.shopService.validateForm" [nzLayout]="'vertical'">
      <nz-select style="width: 400px" nzShowSearch nzAllowClear
                 formControlName="shopInfo"
                 nzPlaceHolder="选择要进入的商店">
        <nz-option *ngFor="let shop of shopStoreList"
                   [nzLabel]="shop.name" [nzValue]="shop"></nz-option>
      </nz-select>
    </form>
  }@else{
    <h3 (click)="openDropdown()">
      当前登录店铺：{{this.shopService.validateForm.value.shopInfo.name}}
      <i nz-icon nzType="down" nzTheme="outline"></i>
    </h3>
  }

</div>
